import React from 'react';
import { View, Text, Pressable, StyleSheet, Platform } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

interface WebConfirmModalProps {
  visible: boolean;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const WebConfirmModal: React.FC<WebConfirmModalProps> = ({
  visible,
  title = 'Confirm',
  message,
  confirmText = 'Discard',
  cancelText = 'Keep Editing',
  onConfirm,
  onCancel,
}) => {
  if (Platform.OS !== 'web' || !visible) return null;

  const overlay = (
    <View style={styles.overlay}>
      <View style={styles.modal}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.message}>{message}</Text>
        <View style={styles.actions}>
          <Pressable style={[styles.button, styles.cancel]} onPress={onCancel}>
            <Text style={styles.cancelText}>{cancelText}</Text>
          </Pressable>
          <Pressable style={[styles.button, styles.confirm]} onPress={onConfirm}>
            <Text style={styles.confirmText}>{confirmText}</Text>
          </Pressable>
        </View>
      </View>
    </View>
  );

  try {
    const g: any = globalThis as any;
    const ReactDOM = g?.require ? g.require('react-dom') : require('react-dom');
    const target = g?.document?.body;
    if (ReactDOM?.createPortal && target) {
      return ReactDOM.createPortal(overlay, target);
    }
  } catch {}

  return overlay;
};

const styles = StyleSheet.create({
  overlay: {
    position: 'fixed' as any,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: 16,
    // Ensure covers viewport entirely
    // Use percentages to satisfy RN types; with fixed positioning it covers viewport
    width: '100%',
    height: '100%',
  },
  modal: {
    width: '100%',
    maxWidth: 420,
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    borderRadius: 10,
    padding: 20,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: ADMIN_COLORS.TEXT.PRIMARY,
    marginBottom: 8,
  },
  message: {
    fontSize: 14,
    color: ADMIN_COLORS.TEXT.SECONDARY,
    marginBottom: 16,
    lineHeight: 20,
  },
  actions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 8,
  },
  button: {
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 8,
  },
  cancel: {
    backgroundColor: ADMIN_COLORS.DATA_TABLE.BACKGROUND,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
  },
  confirm: {
    backgroundColor: ADMIN_COLORS.ERROR,
  },
  cancelText: {
    color: ADMIN_COLORS.TEXT.PRIMARY,
    fontWeight: '600',
  },
  confirmText: {
    color: '#FFFFFF',
    fontWeight: '700',
  },
});
